import { BaseResponse } from "./base-response";

export class LogAuditoria {
    codigoUsuario?: string;
    nombreUsuario?: string;
    agencia?: string;
    codigoCliente?: string;
    pantalla?: string;
    operacion?: string;
    fechaHora?: string;
    latitud?: string;
    longitud?: string;
    extraInfo?: string;
    imei?: string;
    version?: string;
    canalDistribucion?: string;
    aplicacionId?: number;
}

export class LogAuditoriaWrapper extends BaseResponse {
}
  
export class LogAuditoriaGraphql {
    getDatosAnalitica: LogAuditoriaWrapper;
}
